import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { useEffect, useState } from 'react';
import { getStreamByEndpointAsync } from '../../../services/Events';
import { LOG_ENDPOINT } from '../../../services/Events/LogService';
import { IPaginationParams } from '../../../services/types';

interface DeviceLogStreamProps {
  deviceId: number;
}

const DeviceLogStream = ({ deviceId }: DeviceLogStreamProps) => {
  useEffect(() => {}, [deviceId]);
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const columns: IColumnProps[] = [
    { label: 'Descrição', id: 'description' },
    {
      label: 'Data/Hora',
      id: 'createdAt',
      render(val: any) {
        const date = new Date(val);
        return <>{date.toLocaleString('pt-BR')}</>;
      },
    },
  ];

  const getLogs = (pagination: IPaginationParams) => {
    getStreamByEndpointAsync(
      LOG_ENDPOINT + `/${deviceId}`,
      setLogs,
      pagination,
      undefined,
      setIsLoading,
      undefined,
      false,
    );
  };

  useEffect(() => {
    getLogs(pagination);
  }, []);

  return (
    <TableComponent
      columns={columns}
      onChangePageOrRowsPerPage={setPagination}
      isLoading={isLoading}
      emptyMessage={'Nenhuma ocorrência encontrada.'}
      rows={logs}
    />
  );
};

export default DeviceLogStream;
